import React from "react";
import "./Form.css";
import CustomInput from "../customInput/CustomInput";
import CustomButton from "../customButton/CustomButton";

function Form(props) {
  const { style, title } = props;
  return (
    <div className="form_main_container" style={{ ...style }}>
      <form className="form_container">
        <div className="form_heading">
          <div>
            {title}
            <div
              style={{
                borderBottom: "1px solid #05b7a8",
                width: "20%",
                marginLeft: "10px",
                marginTop: "5px",
              }}
            />
          </div>
        </div>
        <CustomInput />
        <CustomInput />
        <CustomInput />
        <div style={{ margin: "10px 0" }}>
          <CustomButton />
        </div>
      </form>
    </div>
  );
}

export default Form;
